module.exports = __webpack_public_path__ + "img/login.68b80502.svg";